module.exports = __webpack_public_path__ + "static/8-b5310e2f734d8c968479659f951744fb.jpg";